import * as React from 'react';
import { translate } from 'react-i18next';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import { getArticleSearchResultsAll, resetSearchData } from 'modules/search/articlesearchresults';
import { IArticleSearchResultsAction, IArticleSearchResultsData } from 'models/search/articlesearchresults';
import { IItemCardList } from 'models/itemcard/itemcardlist';
import * as c from 'models/constants';
import { IUserPreferences } from 'models/user/userpreferences';
import { IInfiniteScrollProps } from 'models/infinitescroll';
import { ItemCardList, NoResults } from 'components';
import { ErrorPage } from 'containers';
import { ResultsWrapper } from 'components/PortalStructure';
import { IResultFilter } from 'models/search/resultfilter';
import { goToCard, getNextPageCount } from 'helpers/common';

interface IProps {
	articleSearchResultsData?: IArticleSearchResultsData;
	getArticleSearchResultsAll?: Redux.ActionCreator<IArticleSearchResultsAction>;
	resetSearchData?: () => IArticleSearchResultsAction;
	userPreferences?: IUserPreferences;
	languageKey?: number;
	t?: (key: string) => string;
	dispatch?: any;
}

@connect(
	(state: IStore) => ({
		articleSearchResultsData: state.articleSearchResults,
		userPreferences: state.userPreferences,
		language: state.userLanguage.languageKey,
	}),
	(dispatch) => ({
		getArticleSearchResultsAll: (
			isFirstLoad: boolean,
			keyword: string,
			queryType: string,
			sortOrder: string,
			lanuageKey: number,
			id?: string,
		) => dispatch(getArticleSearchResultsAll(isFirstLoad, keyword, queryType, sortOrder, lanuageKey, id)),
		resetSearchData: () => dispatch(resetSearchData()),
		dispatch,
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ArticleSearchResults extends React.Component<IProps, any> {
	private sortOrder: string = 'AddedDate DESC';

	constructor(props) {
		super(props);

		this.loadMoreData = this.loadMoreData.bind(this);
		this.orderArticles = this.orderArticles.bind(this);
		this.getArticleSearchResults = this.getArticleSearchResults.bind(this);
		this.goToCard = this.goToCard.bind(this);
	}

	public componentWillUnmount() {
		this.props.resetSearchData();
	}

	public loadMoreData() {
		this.getArticleSearchResults(false);
	}

	public orderArticles(sortorder: number) {
		const sortOrderOptions = ['AddedDate DESC', 'AddedDate ASC'];
		this.sortOrder = sortOrderOptions[sortorder];

		this.getArticleSearchResults(true);
	}

	public getArticleSearchResults(isFirstLoad: boolean) {
		this.props.getArticleSearchResultsAll(
			isFirstLoad,
			this.props.articleSearchResultsData.keyword,
			'search/:keyword',
			this.sortOrder,
			this.props.languageKey,
			null,
		);
	}

	private goToCard(id: string, type: string, target: string) {
		goToCard(this.props.dispatch, id, type, target);
	}

	public render() {
		if (this.props.articleSearchResultsData.error) {
			return <ErrorPage {...this.props} message={this.props.articleSearchResultsData.message} />;
		}

		const { items, itemsPage, isFetching, keyword } = this.props.articleSearchResultsData;
		const { t } = this.props;

		if (!itemsPage) {
			return '';
		}

		const nextPageItems = getNextPageCount(itemsPage, items.length);

		const infiniteScrollProps: IInfiniteScrollProps = {
			dataLength: items.length,
			next: this.loadMoreData,
			hasMore: nextPageItems > 0,
			loader: <h4>{t('BSPortal_Common_Loading')} </h4>,
		};

		const listProps: IItemCardList = {
			items,
			itemType: c.NODE_TYPE_ARTICLE_ITEM_CARD,
			isInfiniteScroll: true,
			infiniteScrollProps,
			currentUserId: this.props.userPreferences.id,
			currentUserIsAdministrator: this.props.userPreferences.isAdministrator,
			currentUserIsEditor: this.props.userPreferences.isEditor,
			isFetching,
			loadingText: t('BSPortal_Common_Loading'),
			noResults: <NoResults keyword={keyword} t={t} />,
			goToCard: this.goToCard,
			nextPageItems,
		};

		const filterProps: IResultFilter = {
			text: t('Search_ArticlesSearchResults_Filter_Title'),
			onFilter: this.orderArticles,
			selectedValue: 0,
			items: [
				{
					text: t('SearchArticles_Filter_Newest'),
					value: 0,
				},
				{
					text: t('SearchArticles_Filter_Oldest'),
					value: 1,
				},
			],
		};

		return (
			<div className="articleSearchResults">
				<ResultsWrapper simpleFilterProps={filterProps}>
					<ItemCardList {...listProps} />
				</ResultsWrapper>
			</div>
		);
	}
}
export { ArticleSearchResults };
